import React from 'react';

import Grid from '@material-ui/core/Grid';

import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';

export default class IVet360Team extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isDirty: false,
            loadingTeam: true,
            iVet360Team: [],
            selectedHospital: props.selectedHospital,
        };
    }

    componentDidMount = async () => {
        this.props.alertIVet360TeamComponentOfHospitalChange(this.alertIVet360TeamComponentOfHospitalChange);
        this.setState({ selectedHospital: this.props.selectedHospital }, this.loadTeam);
    }

    loadTeam = () => {
        let hospital = this.state.selectedHospital;
        let iVet360Team = [
            {
                "role": "Analytics Manager",
                "email": hospital.analyticsManagerEmail,
                "name": hospital.analyticsManagerFullName
            },
            {
                "role": "HR&T Manager",
                "email": hospital.hrtManagerEmail,
                "name": hospital.hrtManagerFullName
            },
            {
                "role": "Marketing Manager",
                "email": hospital.marketingManagerEmail,
                "name": hospital.marketingManagerFullName
            },
            {
                "role": "Bookkeeper",
                "email": hospital.bookkeeperEmail,
                "name": hospital.bookkeeperFullName
            }
        ];

        this.setState({ iVet360Team, loadingTeam: false });
    }

    alertIVet360TeamComponentOfHospitalChange = (hospital) => {
        this.setState({ selectedHospital: hospital }, this.loadTeam);
    }

    onClickTemplate = (rowData) => {
        if (rowData) {
            return <a onClick={() => this.rowColumnClick(rowData.email)}>{rowData.email}</a>
        }
    }

    rowColumnClick(email) {
        window.location.href = `mailto:${email}`;
    }

    render() {
        return (
            <div>
                <br />
                <Grid container style={{ paddingBottom: '10px' }}>

                </Grid>
                {this.state.loadingTeam && <em>Loading...</em>}
                {!this.state.loadingTeam &&
                    <div style={{ paddingBottom: '10px' }}>
                        <DataTable responsive value={this.state.iVet360Team}>
                            <Column field="role" header="Role" sortable="true" />
                            <Column field="name" header="Name" sortable="true" />
                            <Column field="email" header="Email" sortable="true" body={this.onClickTemplate} />
                        </DataTable>
                    </div>
                }
                <br />
                <br />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Hospitals/IVet360Team.js